import React, { useEffect, useRef, useState } from 'react';

import styles from './styles.module.scss';

interface IYoutubeEmbed {
  videoURL: string;
  className?: string;
}

export default function YoutubeEmbed({ videoURL, className } : IYoutubeEmbed) {
  const [videoID, setVideoID] = useState(""); // YouTube Video ID

  const playerRef = useRef<any>(null);
  
  // getting YouTubeVideoID from Youtube Video URL
  const getVideoID = (url: string) => {
    const id = url.split("?v=")[1]?.split("&")[0]

    // If the url to YouTube Video is in wrong format
    if (!id) {
      console.error("Failed to extract video id", url)
      return ""
    }

    return id
  }
  
  // Extracting YouTube Video ID from Youtube Video URL
  useEffect(() => {
    if (videoID !== "") return
    setVideoID(getVideoID(videoURL))
  }, [videoID, videoURL])

  // Playing the video if YouTube API is loaded and the videoID is available
  useEffect(() => {
    if (YT.loaded && videoID !== "") {
      // playing new video
      playerRef.current = new YT.Player('player', {
        videoId: videoID,
        playerVars: {
          mute: 0,
          showinfo: 0,
          controls: 0,
        }
      })
    }

  }, [videoID])

  return (
    <div className={`${styles.youtubeHolder} ${className}`}>
      <div className={styles.youtubeVideo}>
        <div id="player" />
      </div>
    </div>
  )
}
